var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "photo-lower-bar-button-group" }, [
    _c("div", { staticClass: "photo-lower-bar-button" }, [
      _c(
        "div",
        {
          staticClass: "photo-lower-bar-button-text",
          class: {
            "disabled-btn":
              _vm.undoLen === 0 ||
              _vm.undoCounter > 10 ||
              _vm.undoLen - _vm.redoLen === 1
          },
          on: {
            click: function($event) {
              return _vm.undo(_vm.undoLen)
            }
          }
        },
        [_vm._v("Отменить")]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "photo-lower-bar-button" }, [
      _c(
        "div",
        {
          staticClass: "photo-lower-bar-button-text",
          class: { "disabled-btn": _vm.redoLen === 0 },
          on: {
            click: function($event) {
              return _vm.redo(_vm.redoLen)
            }
          }
        },
        [_vm._v("Повторить")]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "photo-lower-bar-button-custom",
        on: {
          click: function($event) {
            return _vm.rotate(-90)
          }
        }
      },
      [_c("SVGPhotoRotateLeftE", { staticClass: "lb-svg-rotate" })],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "photo-lower-bar-button-custom no-left-padding",
        on: {
          click: function($event) {
            return _vm.rotate(90)
          }
        }
      },
      [_c("SVGPhotoRotateRightE", { staticClass: "lb-svg-rotate" })],
      1
    ),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "photo-lower-bar-button", on: { click: _vm.crop } },
      [
        _c("SVGPhotoCut", { staticClass: "lb-svg" }),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass:
              "photo-lower-bar-button-text extra-left-padding collapsable"
          },
          [_vm._v("Кадрировать")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "photo-lower-bar-button",
        on: {
          click: function($event) {
            return _vm.showModal("photo-delete-modal")
          }
        }
      },
      [
        _c("SVGPhotoDelete", { staticClass: "lb-svg" }),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass:
              "photo-lower-bar-button-text extra-left-padding collapsable",
            on: {
              click: function($event) {
                return _vm.showModal("photo-delete-modal")
              }
            }
          },
          [_vm._v("Удалить")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "photo-lower-bar-button no-left-padding collapsable" },
      [
        _c(
          "div",
          {
            staticClass: "photo-lower-bar-button-text",
            staticStyle: { cursor: "default", color: "#939393" }
          },
          [_vm._v("Повернуть")]
        )
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }